module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px",
      "text-align": "center",
      "padding-top": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.53333in",
      "height": "3.57361in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 75
// module chunks = 0